import { Box, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import React, { FC } from 'react'

import { useLayoutPlugStyles } from './layout-plug.styles'
import { TranslationDictionary } from 'src/utils'
import Image from 'next/image'

interface ILayoutPlugProps {
  translate?: TranslationDictionary['data']
}

export const LayoutPlug: FC<ILayoutPlugProps> = ({ translate }) => {
  const classes = useLayoutPlugStyles()

  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'))
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const imgName = isMobile
    ? 'plug-img-mobile'
    : isTablet && !isMobile
    ? 'plug-img-tablet'
    : 'plug-img'

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Box className={classes.contentLeft}>
          <Typography variant="h1" className={classes.title}>
            {translate?.['term-works'] ??
              `В данный момент ведутся технические работы,
              в связи с чем сервис временно недоступен.`}
          </Typography>
          <Typography variant="subtitle1" className={classes.subtitle}>
            {translate?.apologies ??
              'Приносим свои извинения за причиненные неудобства.'}
          </Typography>
        </Box>
        <Box className={classes.contentRight}>
          <Image
            width={658}
            height={654}
            className={classes.plugImg}
            src={`/blog/assets/${imgName}.png`}
            alt=""
          />
        </Box>
      </Box>
    </Box>
  )
}
